






















import Card from './Card.vue'

export default {
  components: {
    Card
  },
  props: {
    firstName: { type: String, required: true },
    lastName: { type: String, required: true },
    email: { type: String, required: true },
    phone: { type: String, default: null },
    jobTitle: { type: String, default: null },
    cardTitle: {
      type: String,
      default: function() {
        return this.$t('myAssignments.contactCard.contactAtSennder')
      }
    }
  },
  computed: {
    emailLink() {
      return 'mailto:' + this.email
    }
  }
}
